var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33162 7.5C4.94671 8.16667 3.98446 8.16667 3.59956 7.5L0.135463 1.5C-0.249437 0.833333 0.231689 -7.60534e-07 1.00149 -6.93236e-07L7.92969 -8.75532e-08C8.69949 -2.02551e-08 9.18062 0.833334 8.79572 1.5L5.33162 7.5Z",
    fill: "#FF182A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down_icon.fa285d20f411290501a79ded95e5681c.svg";
export { ForwardRef as ReactComponent };